export const detailUrl = ({ id }) => {
  return `/documents/detail/${id}`;
};
export const overviewUrl = () => {
  return `/documents`;
};
